export const INSIGHTS = [
  {
    id: 'ucp-600',
    path: '/insights/ucp-600',
    accent: '#6366F1',
    meta: {
      'zh-TW': {
        category: 'B2B 金融科技與 AI',
        title: 'AI 如何依 UCP 600 預先核對信用證單據，及早發現瑕疵',
        desc: '自動化單據解析如何幫助出口商在交單前發現可能的瑕疵，從而避免部分拒付後隨之而來的銀行費用與延誤。',
        date: '2026 年 8 月',
      },
      'zh-CN': {
        category: 'B2B 金融科技与 AI',
        title: 'AI 如何依 UCP 600 预先核对信用证单据，及早发现瑕疵',
        desc: '自动化单据解析如何帮助出口商在交单前发现可能的瑕疵，从而避免部分拒付后随之而来的银行费用与延误。',
        date: '2026 年 8 月',
      },
      en: {
        category: 'B2B FinTech & AI',
        title: 'How AI Pre-Checks LC Documents Against UCP 600 to Catch Discrepancies Earlier',
        desc: 'How automated document parsing helps exporters spot likely discrepancies before presenting, and avoid some of the bank fees and delays that follow a refusal.',
        date: 'August 2026',
      },
    },
  },
  {
    id: 'zero-storage',
    path: '/insights/zero-storage',
    accent: '#6366F1',
    meta: {
      'zh-TW': {
        category: '企業 AI 架構',
        title: '私隱優先架構：企業 AI 時代的設計哲學',
        desc: '當最敏感的合約與貿易單據交給 AI 處理，「分析後不儲存於伺服器」為何是企業最在意的安全承諾。',
        date: '2026 年 7 月',
      },
      'zh-CN': {
        category: '企业 AI 架构',
        title: '隐私优先架构：企业 AI 时代的设计哲学',
        desc: '当最敏感的合同与贸易单据交给 AI 处理，「分析后不存储于服务器」为何是企业最在意的安全承诺。',
        date: '2026 年 7 月',
      },
      en: {
        category: 'Enterprise AI Architecture',
        title: 'Privacy-First Architecture: A Design Philosophy for the Enterprise AI Era',
        desc: 'When your most sensitive contracts and trade documents meet AI, why "not saved to our servers after analysis" is the promise enterprises care about most.',
        date: 'July 2026',
      },
    },
  },
  {
    id: 'construction-ai',
    path: '/insights/construction-ai',
    accent: '#F59E0B',
    meta: {
      'zh-TW': {
        category: 'B2B 建築科技與 AI',
        title: 'AI 如何在簽約前審查美國分包合約的條款風險',
        desc: '拆解 AI 如何解析分包合約，標記違約賠償金、彌償與付款條件等高風險條款。',
        date: '2026 年 6 月',
      },
      'zh-CN': {
        category: 'B2B 建筑科技与 AI',
        title: 'AI 如何在签约前审查美国分包合同的条款风险',
        desc: '拆解 AI 如何解析分包合同，标记违约赔偿金、弥偿与付款条件等高风险条款。',
        date: '2026 年 6 月',
      },
      en: {
        category: 'B2B ConTech & AI',
        title: 'How AI Reviews US Subcontract Clause Risk Before You Sign',
        desc: 'How AI parses subcontracts and flags high-risk clauses — liquidated damages, indemnities, and payment conditions.',
        date: 'June 2026',
      },
    },
  },
];
